export class ForbiddenError extends Error {
  constructor(message?: string) {
    super(message)
    Object.setPrototypeOf(this, ForbiddenError.prototype)
  }
}
